import { getStyle } from "../../hooks/use-styles";

const HexTitle = ({ title, className, titleStyle }) => {
  return (
    <div
      className={`weight-500 mb-0 capitalize ${className || ""}`}
      style={{ color: getStyle("primaryBlack"), ...titleStyle }}
    >
      {title}
    </div>
  );
};

export default HexTitle;
